import { createElement } from "./globalFunctions";
const language = dataLayer[0].shoptet.language;

/**
 * Add a title to the filters boolean section
 *
 * @param {string} title - The title to be added to the filters boolean section
 */
const addTitleToFiltersBoolean = (title) => {
  const filtersBoolean = document.querySelector(".filter-section-boolean");
  if (filtersBoolean) {
    const help = filtersBoolean.querySelector("h4");
    if (help) return;
    const filtersBooleanHeading = createElement("h4", [], title);
    filtersBoolean.prepend(filtersBooleanHeading);
  }
};

/**
 * Make filter titles clickable
 * Adds an event listener to the filter titles that toggles the visibility of the filter form
 * Saves the state of the filter form visibility to the sessionStorage
 * The state is saved as an array of strings with the class names of the filter sections
 * Use `filter-form-visible` class to show the filter form
 */
const makeFilterTitlesClickable = () => {
  const filterSections = document.querySelectorAll(".filter-section");
  for (const section of filterSections) {
    let heading = section.querySelector("h4");
    if (!heading) continue;
    heading.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();

      // Odeber filter-form-visible všem sourozencům
      for (const sibling of filterSections) {
        if (sibling !== section) {
          sibling.classList.remove("filter-form-visible");
        }
      }

      // Přepni filter-form-visible na aktuální sekci
      section.classList.toggle("filter-form-visible");

      // Uložení do sessionStorage
      let cache =
          JSON.parse(window.sessionStorage.getItem("openedFilters")) || [],
        parentClass = e.currentTarget.parentElement.className;
      parentClass = parentClass.replace("filter-form-visible", "");
      parentClass = parentClass.trim();

      // Jen jeden filtr může být otevřený
      cache = [parentClass];
      if (!section.classList.contains("filter-form-visible")) {
        cache = [];
      }
      window.sessionStorage.setItem("openedFilters", JSON.stringify(cache));
    });
  }
  // Podobně upravit i priceFilterCustom
  const priceFilterCustom = document.querySelector(".slider-wrapper");
  if (priceFilterCustom) {
    priceFilterCustom.querySelector("h4").addEventListener("click", (e) => {
      // Odebrat z ostatních
      for (const sibling of filterSections) {
        sibling.classList.remove("filter-form-visible");
      }
      priceFilterCustom.classList.toggle("filter-form-visible");

      let cache = [];
      if (priceFilterCustom.classList.contains("filter-form-visible")) {
        cache = [priceFilterCustom.classList[0]];
      }
      window.sessionStorage.setItem("openedFilters", JSON.stringify(cache));
    });
  }
};

/**
 * Create a button to show subcategories
 * Toggle `show` class on the subcategories element
 * @param {string} text - The text of the button
 */
const createShowSubcategoriesButton = (text) => {
  const subcategories = document.querySelector(".subcategories");
  if (!subcategories) return;
  const showCategoriesBtn = createElement(
    "button",
    ["show-categories", "btn"],
    text
  );
  showCategoriesBtn.addEventListener("click", () => {
    subcategories.classList.toggle("show");
  });
};

// give ID to bottom description of category, so that it can be refered to from top description
const addIDToDescription = () => {
  const secondaryDesc = document.querySelector(".category__secondDescription");
  if (secondaryDesc) secondaryDesc.id = "secondDescription";
};
const moveSecondDescription = () => {
  const secondaryDesc = document.querySelector(".category__secondDescription");
  if (!secondaryDesc) return;
  const mainContent = document.querySelector("#content");
  if (!mainContent) return;
  mainContent.appendChild(secondaryDesc);
};

const createCategoryWrapper = () => {
  if (document.querySelector(".custom-category-wrapper")) {
    const categoryTopDuplicate = document.querySelector(
      "#content > .category-top"
    );
    if (categoryTopDuplicate) categoryTopDuplicate.remove();
  } else {
    const categoryTop = document.querySelector(".category-top");
    const breadcrumbsWrapper = document.querySelector(".breadcrumbs-wrapper");
    if (categoryTop) {
      categoryTop.classList.add("container");
      const customCategoryWrapper = createElement("div", [
        "custom-category-wrapper",
      ]);
      customCategoryWrapper.append(categoryTop);
      if (breadcrumbsWrapper) breadcrumbsWrapper.after(customCategoryWrapper);
    }
  }
};

const handleTopProducts = () => {
  const productsTop = document.querySelector("#productsTop");
  const contentWrapper = document.querySelector("#content-wrapper");
  if (productsTop) {
    const productsTopHeading = productsTop.previousElementSibling;
    if (contentWrapper) {
      contentWrapper.prepend(productsTop);
      if (productsTopHeading) {
        contentWrapper.prepend(productsTopHeading);
        productsTopHeading.classList.add("productsTopHeading");
      }
    }

    const topProductBottoms = productsTop.querySelectorAll(
      ".product .p-bottom > div"
    );
    if (topProductBottoms.length) {
      for (let bottom of topProductBottoms) {
        if (!bottom.querySelector(".p-tools")) {
          const newPTools = document.createElement("div");
          if (
            !bottom.querySelector(
              "div[data-micro-availability='https://schema.org/OutOfStock']"
            ) &&
            dataLayer[0].shoptet.customer.registered === true
          ) {
            const detailBottom = document.createElement("form");
            detailBottom.innerHTML = `
					
						<input type="hidden" name="language" value="cs">                                                     
						<input type="hidden" name="amount" autocomplete="off" class="">
						<button type="submit" class="btn btn-cart add-to-cart-button"><span>${
              language === "cs" ? "Přidat" : "Přidať"
            }</span></button>
						`;
            newPTools.classList.add("p-tools");

            const toCart = detailBottom.querySelector(".add-to-cart-button");
            const pCode = bottom
              .closest(".product")
              .querySelector('span[data-micro="sku"]')
              .textContent.trim();
            if (toCart) {
              toCart.addEventListener("click", (e) => {
                e.preventDefault();
                const inputValue = detailBottom.querySelector(
                  'input[name="amount"]'
                ).value;

                shoptet.cartShared.addToCart({
                  productCode: pCode,
                  amount: inputValue,
                });
              });
            }
            newPTools.appendChild(detailBottom);
          } else if (!bottom.querySelector("a.btn")) {
            const detailBtn = document.createElement("a");
            detailBtn.classList.add("btn", "btn-primary");
            detailBtn.href = bottom
              .closest(".product")
              .querySelector("a.image").href;
            detailBtn.innerText =
              language === "cs" ? "Zobrazit detail" : "Zobraziť detail";
            newPTools.appendChild(detailBtn);
          }

          bottom.appendChild(newPTools);
        }
      }
    }
  }
};

const categoryHead = () => {
  const categoryTop = document.querySelector(".category-top");
  const haveToRemove = document.querySelector(
    "#content-wrapper > .category-top"
  );
  if (haveToRemove) {
    const initialCategoryTop = document.querySelector(
      "#content > .category-top"
    );
    if (initialCategoryTop) initialCategoryTop.remove();
  }
  if (!categoryTop) return;

  let imagesLoading = [];
  let topImg;

  const categoryPerex = categoryTop.querySelector(".category-perex");
  if (categoryPerex) {
    const categoryPerexWrapper = document.querySelector(
      ".category-perex-wrapper"
    );
    if (categoryPerexWrapper) {
      const perexImgs = categoryPerexWrapper.querySelectorAll("img");
      if (perexImgs.length) {
        perexImgs.forEach((img) => {
          imagesLoading.push(
            new Promise((resolve) => {
              if (img.complete) {
                topImg = img.src;
                const closestP = img.closest("p");
                if (closestP) closestP.remove();
                resolve();
              } else {
                img.addEventListener("load", () => {
                  topImg = img.src;
                  const closestP = img.closest("p");
                  if (closestP) closestP.remove();
                  resolve();
                });
              }
            })
          );
        });

        Promise.all(imagesLoading).then(() => {
          if (!categoryTop.querySelector(".category-header-image")) {
            const categoryHeaderImage = document.createElement("img");
            categoryHeaderImage.classList.add("category-header-image");
            categoryHeaderImage.src = topImg;
            categoryTop.append(categoryHeaderImage);
          }
        });
      }
    }

    const catHeading = categoryTop.querySelector(".category-title");
    const headingPlaceholder = categoryTop.querySelector(".h1-placeholder");

    if (catHeading) {
      if (window.innerWidth <= 767) {
        // Mobilní verze - přesuneme nadpis do placeholderu
        if (headingPlaceholder) {
          headingPlaceholder.innerHTML = "";
          headingPlaceholder.append(catHeading);
        }
      } else {
        // Desktop - vrátíme nadpis zpět do categoryPerex pokud tam není
        if (categoryPerex && !categoryPerex.contains(catHeading)) {
          categoryPerex.prepend(catHeading);
        }
      }
    }

    const subcategories = document.querySelector(".subcategories");
    if (subcategories) {
      if (window.innerWidth <= 767) {
        categoryTop.after(subcategories);
      } else {
      }

      const subCatImages = subcategories.querySelectorAll(".image img");
      if (subCatImages.length) {
        subCatImages.forEach((img) => {
          img.setAttribute("height", "140");
          const dataSrc = img.getAttribute("data-src");
          if (dataSrc) {
            img.setAttribute("data-src", dataSrc.replace("thumb", "orig"));
          } else if (img.src) {
            img.src = img.src.replace("thumb", "orig");
          }
        });
      }
    }
  }
};
const loadMoreTopProductsBtn = () => {
  const productsTop = document.querySelector("#productsTop");
  if (!productsTop) return;
  const productsTopElm = productsTop.querySelectorAll(".product.inactive");
  console.log(productsTopElm.length);
  const loadMoreBtn = document.querySelector(".toggle-top-products");
  if (!loadMoreBtn) return;
  if (productsTopElm.length > 0) {
    loadMoreBtn.textContent =
      language === "cs"
        ? `Zobrazit více (${productsTopElm.length})`
        : `Ukazať viac (${productsTopElm.length})`;
  }
};
const moveCategoryTop = () => {
  const contentWrapper = document.querySelector("#content-wrapper");
  const categoryTop = document.querySelector(".category-top");

  if (!contentWrapper || !categoryTop) return;

  categoryTop.classList.add("moved");
  contentWrapper.prepend(categoryTop);
  //contentWrapper.insertAdjacentElement("beforebegin", categoryTop);
};
const makeBackgroundImageCategoryPerex = () => {
  const categoryPerex = document.querySelector(
    ".category-perex:not(.empty-content)"
  );
  if (!categoryPerex) return;

  const categoryImage = document.querySelector(".category-image");

  if (window.innerWidth < 768) {
    if (!categoryPerex.parentElement.querySelector(".category-perex-image")) {
      const categoryImageEl = document.createElement("img");
      categoryImageEl.src = categoryImage
        ? categoryImage.src
        : "https://698129.myshoptet.com/user/documents/upload/depositphotos_696072920-stock-photo-views-mont-blanc-glacier-lac.jpg";
      categoryImageEl.alt = "";
      categoryImageEl.classList.add("category-perex-image");
      categoryPerex.style.backgroundImage = "none";
      categoryPerex.parentElement.prepend(categoryImageEl);
    }
  } else {
    const mobileImg = categoryPerex.parentElement.querySelector(
      ".category-perex-image"
    );
    if (mobileImg) mobileImg.remove();
    categoryPerex.style.backgroundImage = `url(${
      categoryImage
        ? categoryImage.src
        : "https://698129.myshoptet.com/user/documents/upload/depositphotos_696072920-stock-photo-views-mont-blanc-glacier-lac.jpg"
    })`;
    categoryPerex.style.backgroundSize = "cover";
    categoryPerex.style.backgroundPosition = "center";
    categoryPerex.style.backgroundRepeat = "no-repeat";
  }
  subcategoriesToPerex();
  breadcrumbsToPerex();
};
const subcategoriesToPerex = () => {
  const categoryPerex = document.querySelector(
    ".category-perex:not(.empty-content)"
  );

  const subcategories = document.querySelector(".subcategories");
  if (!subcategories) return;

  categoryPerex.appendChild(subcategories);
};
const breadcrumbsToPerex = () => {
  const categoryPerex = document.querySelector(
    ".category-perex:not(.empty-content)"
  );
  const breadcrumbsWrapper = document.querySelector(".breadcrumbs-wrapper");
  if (!breadcrumbsWrapper) return;
  if (window.innerWidth < 992) return;
  categoryPerex.prepend(breadcrumbsWrapper);
};
function addHideFiltersButton() {
  const filters = document.getElementById("filters");
  if (!filters) return;

  const btnExists = filters.querySelector(".btn.btn-primary");
  if (btnExists) return;

  const btn = document.createElement("a");
  btn.href = "#";
  btn.className = "btn btn-primary";
  btn.textContent = "Schovat filtraci";
  if (window.innerWidth < 768) {
    btn.textContent = language === "cs" ? "Zavřít filtrace" : "Zavrieť filtre";
  }
  btn.addEventListener("click", function (e) {
    e.preventDefault();
    filters.classList.remove("visible");
  });

  filters.appendChild(btn);
}

const handleCheckedFilters = () => {
  const filterSections = document.querySelector(".filter-sections");
  if (filterSections) {
    const activeFilters =
      filterSections.querySelectorAll(
        '#filters input[type="checkbox"]:checked+label'
      ) ||
      document.querySelectorAll(
        '#filters input[type="checkbox"]:checked+label'
      );
    if (activeFilters.length) {
      // console.log(activeFilters)
      // const categoryContent = document.querySelector('#content')
      // const categoryContent = document.querySelector('.category-top')
      let activeFiltersWrapper = document.createElement("div"),
        // activeFiltersTitle = document.createElement('strong'),
        activeFiltersList = document.createElement("div");
      // activeFiltersTitle.classList.add('active-title')
      activeFiltersWrapper.classList.add("active-filters");
      activeFiltersList.classList.add("active-list");
      // activeFiltersWrapper.appendChild(activeFiltersTitle)
      activeFiltersWrapper.appendChild(activeFiltersList);
      // activeFiltersTitle.textContent = language === 'cs' ? 'Vybrané filtry: ' : 'Vybrané filtre: '
      activeFilters.forEach((item) => {
        if (item.classList.contains("no-display")) {
          const itemClone = item.cloneNode(true);
          itemClone.classList.remove("no-display");
          activeFiltersList.appendChild(itemClone);
        } else {
          activeFiltersList.appendChild(item.cloneNode(true));
        }
        // const itemSection = item.closest('.filter-section')
        // if (itemSection) {
        // 	const itemSectionTitle = itemSection.querySelector('h4')
        // 	if (itemSectionTitle) {
        // 		const sectionTitle = createElement('div', ['section-title'], itemSectionTitle.textContent)
        // 		activeFiltersList.appendChild(sectionTitle)
        // 	}
        // }
      });
      let deleteFilters = document.querySelector("#clear-filters");
      if (deleteFilters) {
        const deleteFiltersLink = deleteFilters.querySelector("a");
        if (deleteFiltersLink) {
          deleteFiltersLink.textContent =
            language === "cs"
              ? "Zrušit všechny filtry"
              : "Zrušiť všetky filtre";
          deleteFiltersLink.addEventListener("click", () => {
            window.sessionStorage.setItem("openedFilters", JSON.stringify([]));
          });
        }
        activeFiltersWrapper.appendChild(deleteFilters);
      }
      if (filterSections.querySelector(".active-filters"))
        filterSections.querySelector(".active-filters").remove();
      const filtersWrapper = document.querySelector("#filters-wrapper");
      const otherCategory = document.querySelector(".other-category-wrapper");
      if (filtersWrapper) filtersWrapper.append(activeFiltersWrapper);
      // filterSections.appendChild(activeFiltersWrapper)
      // if (otherCategory) {
      // 	otherCategory.prepend(activeFiltersWrapper)
      // } else {
      // 	filtersWrapper.parentElement.insertBefore(activeFiltersWrapper, filtersWrapper.nextElementSibling)
      // }

      // filterSections.appendChild(activeFiltersWrapper)
      const sidebarInner = document.querySelector(
        ".sidebar-left .sidebar-inner"
      );
      const selectedFiltersTitle = createElement(
        "h4",
        ["active-filters-title"],
        language === "cs" ? "Vybrané filtry " : "Vybrané filtre "
      );
      activeFiltersWrapper.prepend(selectedFiltersTitle);
      if (!sidebarInner) return;
      const filtersBox = document.querySelector(
        ".sidebar-filters-wrapper .box-filters"
      );
      if (!filtersBox) return;
      filtersBox.appendChild(activeFiltersWrapper);
    }
  }
};

const handleTotalProductCount = () => {
  const totalProductCount = document.querySelector("#category-header > div");
  if (!totalProductCount) return;
  totalProductCount.classList.add("total-product-count");
  const totalCountStrong = totalProductCount.querySelector("strong");
  if (!totalCountStrong) return;
  const count = parseInt(totalCountStrong.textContent);
  const countTitle = createElement(
    "strong",
    ["total-product-count-title"],
    language === "cs" ? "Nalezeno: " : "Nájdených: "
  );
  if (count === 0) {
    totalProductCount.innerText =
      language === "cs" ? "Žádné produkty" : "Žiadne produkty";
  } else if (count === 1) {
    countTitle.textContent = language === "cs" ? "Nalezen: " : "Nájdený: ";
    totalProductCount.innerText = totalProductCount.innerText.replace(
      " položek celkem",
      " produkt"
    );
  } else if (count > 1 && count < 5) {
    countTitle.textContent = language === "cs" ? "Nalezeny: " : "Nájdené: ";
    totalProductCount.innerText = totalProductCount.innerText.replace(
      " položek celkem",
      " produkty"
    );
  } else {
    totalProductCount.innerText = totalProductCount.innerText.replace(
      " položek celkem",
      " produktů"
    );
  }
  if (count > 0) {
    totalProductCount.prepend(countTitle);
  }
};

const changeTextInFilterBtn = () => {
  const unveilBtn = document.querySelector(
    ".filters-unveil-button-wrapper .btn-default.unveil-button"
  );
  if (unveilBtn) {
    unveilBtn.textContent = window.language === "cs" ? "Filtrace" : "Filtracia";
    unveilBtn.addEventListener("click", () => {
      unveilBtn.classList.toggle("active");
      unveilBtn.textContent =
        window.language === "cs" ? "Filtrace" : "Filtracia";
    });
    unveilBtn.setAttribute(
      "data-text",
      window.language === "cs" ? "Filtrace" : "Filtracia"
    );
  }
};

const changeTextInPagination = (textToTop, textToLoader) => {
  const pagination = document.querySelector(".pagination-wrapper");

  if (pagination) {
    const paginationTop = pagination.querySelector(
      ".pagination-top strong.js-scroll-top"
    );
    const paginationLoaderBtn = pagination.querySelector(
      ".pagination-loader .btn"
    );
    if (paginationTop) paginationTop.textContent = textToTop;
    if (paginationLoaderBtn) paginationLoaderBtn.textContent = textToLoader;
  }
};
const fixPaginationScroll = () => {
  let scrollProductsOffset = 119;
  // let scrollProductsOffset = -250
  const header = document.querySelector("#header");
  if (header) {
    const headerHeight = header.offsetHeight;
    scrollProductsOffset = headerHeight + 20;
  }

  document.addEventListener("ShoptetPagePaginationUsed", () => {
    document.addEventListener("ShoptetDOMContentLoaded", () => {
      setTimeout(() => {
        const target = document.querySelector(".category-content-wrapper");
        if (!target) return;

        const targetPosition =
          target.getBoundingClientRect().top +
          window.scrollY -
          scrollProductsOffset;
        window.scrollTo({ top: targetPosition, behavior: "smooth" });
        // target.scrollIntoView({ behavior: 'smooth' })
        // console.log('scrolled')
      }, 500);
    });
  });
};

const moveBestSellers = () => {
  const bestSellersWrapper = document.querySelector("#productsTop");
  if (!bestSellersWrapper) return;

  let bestSellersHeader = bestSellersWrapper.previousElementSibling;
  if (!bestSellersHeader || bestSellersHeader.tagName !== "H4") return;

  const bestSellers = createElement("div");
  bestSellers.classList.add("best-sellers");
  bestSellers.append(bestSellersHeader);
  bestSellers.append(bestSellersWrapper);

  const categoryWrapper = document.querySelector(".category-content-wrapper");
  if (!categoryWrapper) return;
  categoryWrapper.prepend(bestSellers);
};

const wrapCategoryPerex = () => {
  const categoryPerex = document.querySelector(".category-perex");
  if (!categoryPerex) return;

  // Pokud už wrapper existuje, nic nedělej
  if (categoryPerex.querySelector(".category-perex-wrapper")) return;

  const categoryPerexWrapper = createElement("div");
  categoryPerexWrapper.classList.add("category-perex-wrapper");

  while (categoryPerex.firstChild) {
    categoryPerexWrapper.appendChild(categoryPerex.firstChild);
  }
  categoryPerex.appendChild(categoryPerexWrapper);
};
const mergeFlags = () => {
  const products = document.querySelectorAll(".products-block .product");
  if (!products.length) return;
  products.forEach((product) => {
    const flagExtra = product.querySelector(".flags-extra");
    if (!flagExtra) return;
    const flagAction = product.querySelector(".flag-action");
    if (!flagAction) return;
    const flagDiscount = product.querySelector(".flag-discount");
    if (!flagDiscount) return;
    const flagActionAndDiscount = document.createElement("span");
    flagActionAndDiscount.classList.add("flag-action-discount");
    flagActionAndDiscount.appendChild(flagAction);
    flagActionAndDiscount.appendChild(flagDiscount);
    flagExtra.appendChild(flagActionAndDiscount);
  });
};
const moveParameterWrapper = () => {
  const productsBlock = document.querySelector(".products-block");
  if (!productsBlock) return;
  const product = productsBlock.querySelectorAll(".product");
  if (!product) return;
  product.forEach((item) => {
    const parameterWrapper = item.querySelector(".widget-parameter-wrapper");
    const pBottom = item.querySelector(".p-bottom>div");
    if (!parameterWrapper || !pBottom) return;
    pBottom.appendChild(parameterWrapper);
  });
};
const wrapPtoolsandPrice = () => {
  const productsBlock = document.querySelectorAll(".products-block");

  if (!productsBlock) return;
  productsBlock.forEach((productsBlock) => {
    const product = productsBlock.querySelectorAll(".product");

    if (!product) return;
    product.forEach((item) => {
      const pTools = item.querySelector(".p-tools");

      const pPrice = item.querySelector(".prices");
      if (!pTools || !pPrice) return;

      const pToolsAndPriceWrapper = createElement("div", ["p-tools-and-price"]);
      pToolsAndPriceWrapper.appendChild(pPrice);
      pToolsAndPriceWrapper.appendChild(pTools);

      item.querySelector(".p-bottom").appendChild(pToolsAndPriceWrapper);
    });
  });
};
const bannersInCategory = () => {
  setTimeout(() => {
    document
      .querySelectorAll(".banner-category")
      .forEach((banner) => banner.remove());

    const bannerCategoryOneEl = categoryBanner1
      ? document.querySelector(categoryBanner1)
      : null;

    if (!bannerCategoryOneEl) return;

    if (bannerCategoryOneEl) bannerCategoryOneEl.style.display = "none";

    const productsBlock = document.querySelector(".products-block");
    if (!productsBlock) return;

    const products = Array.from(
      productsBlock.querySelectorAll(".product")
    ).filter((el) => !el.classList.contains("banner-category"));

    const firstProduct = products[7];

    if (bannerCategoryOneEl && firstProduct) {
      const firstBanner = createElement("div", [
        "banner-category",
        "banner-category-1",
      ]);
      firstBanner.innerHTML = bannerCategoryOneEl.innerHTML;
      firstProduct.insertAdjacentElement("afterend", firstBanner);
    }
  }, 250);
};
const sortingDropdown = () => {
  const form = document.querySelector("#category-header form");
  if (!form) return;
  const fs = form.querySelector("fieldset");
  if (!fs) return;

  // --- načti volby z původních radios ---
  const radios = [...fs.querySelectorAll('input[type="radio"][name="order"]')];
  if (!radios.length) return;

  const options = radios.map((r) => {
    const lab = fs.querySelector('label[for="' + r.id + '"]');
    return {
      value: r.value,
      text: (lab ? lab.textContent : r.value).trim(),
      url: r.dataset.url || "",
      selected: r.checked,
    };
  });

  // vyčisti fieldset a připrav wrapper
  fs.innerHTML = "";
  const wrap = document.createElement("div");
  wrap.className = "sort-select-wrap";
  fs.appendChild(wrap);

  // --- trigger (tlačítko) ---
  const trigger = document.createElement("button");
  trigger.type = "button";
  trigger.className = "sort-trigger";
  trigger.setAttribute("aria-haspopup", "listbox");
  trigger.setAttribute("aria-expanded", "false");
  trigger.textContent = (options.find((o) => o.selected) || options[0]).text;
  wrap.appendChild(trigger);

  // --- menu ---
  const menu = document.createElement("div");
  menu.className = "sort-menu";
  menu.setAttribute("role", "listbox");
  wrap.appendChild(menu);

  options.forEach((o) => {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "sort-item";
    btn.setAttribute("role", "option");
    btn.setAttribute("data-value", o.value);
    btn.dataset.url = o.url;
    btn.textContent = o.text;
    if (o.selected) btn.setAttribute("aria-selected", "true");
    menu.appendChild(btn);
  });

  function openMenu() {
    menu.classList.add("open");
    trigger.setAttribute("aria-expanded", "true");
    // fokus na aktuální položku
    const current =
      menu.querySelector('[aria-selected="true"]') ||
      menu.querySelector(".sort-item");
    if (current) current.focus();
    document.addEventListener("click", onDocClick);
    document.addEventListener("keydown", onKey);
  }
  function closeMenu() {
    menu.classList.remove("open");
    trigger.setAttribute("aria-expanded", "false");
    document.removeEventListener("click", onDocClick);
    document.removeEventListener("keydown", onKey);
  }
  function onDocClick(e) {
    if (!wrap.contains(e.target)) closeMenu();
  }
  function onKey(e) {
    if (e.key === "Escape") {
      closeMenu();
      trigger.focus();
    }
    if (!menu.classList.contains("open")) return;
    const items = [...menu.querySelectorAll(".sort-item")];
    const idx = items.indexOf(document.activeElement);
    if (e.key === "ArrowDown") {
      e.preventDefault();
      items[Math.min(idx + 1, items.length - 1)].focus();
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      items[Math.max(idx - 1, 0)].focus();
    } else if (
      e.key === "Enter" &&
      document.activeElement.classList.contains("sort-item")
    ) {
      document.activeElement.click();
    }
  }

  trigger.addEventListener("click", function () {
    if (menu.classList.contains("open")) closeMenu();
    else openMenu();
  });

  menu.addEventListener("click", function (e) {
    const item = e.target.closest(".sort-item");
    if (!item) return;
    // vizuálně označ
    menu
      .querySelectorAll('.sort-item[aria-selected="true"]')
      .forEach((x) => x.removeAttribute("aria-selected"));
    item.setAttribute("aria-selected", "true");
    trigger.textContent = item.textContent;
    closeMenu();
    // akce – redirect
    const url = item.dataset.url;
    if (url) window.location.href = url;
    else form.submit();
  });
};
export {
  addTitleToFiltersBoolean,
  moveBestSellers,
  makeFilterTitlesClickable,
  createShowSubcategoriesButton,
  makeBackgroundImageCategoryPerex,
  categoryHead,
  moveCategoryTop,
  handleCheckedFilters,
  addIDToDescription,
  createCategoryWrapper,
  handleTopProducts,
  handleTotalProductCount,
  changeTextInFilterBtn,
  changeTextInPagination,
  fixPaginationScroll,
  addHideFiltersButton,
  breadcrumbsToPerex,
  subcategoriesToPerex,
  wrapCategoryPerex,
  loadMoreTopProductsBtn,
  mergeFlags,
  moveParameterWrapper,
  wrapPtoolsandPrice,
  bannersInCategory,
  moveSecondDescription,
  sortingDropdown,
};
